import { aaColors } from '@design-system';
import NextHead from 'next/head';

import { truncateString } from '../../utils/strings';
import { LayoutTheme } from './types';

type Props = {
  title: string;
  description?: string;
  urls?: { canonical?: string };
  theme?: LayoutTheme;
};

const Head = ({
  description = '',
  theme = 'light',
  title = '',
  urls: { canonical } = {},
}: Props) => {
  const mapThemeFavicon = {
    light: '/favicon.ico?v=2',
    dark: '/favicon-dark.ico?v=2',
    'light-grey': '/favicon.ico?v=2',
    'dark-grey': '/favicon.ico?v=2',
  };

  const mapThemeIcon16 = {
    light: '/favicon-16x16.png',
    dark: '/favicon-dark-16x16.png',
    'light-grey': '/favicon-16x16.png',
    'dark-grey': '/favicon-16x16.png',
  };

  const mapThemeIcon32 = {
    light: '/favicon-32x32.png',
    dark: '/favicon-dark-32x32.png',
    'light-grey': '/favicon-32x32.png',
    'dark-grey': '/favicon-32x32.png',
  };

  const mapThemeColor = {
    light: '#ffffff',
    dark: aaColors.neutral[6],
    'light-grey': '#ffffff',
    'dark-grey': '#000000',
  };

  return (
    <NextHead>
      <meta charSet="UTF-8" />
      <title>{title}</title>
      <meta content={truncateString(description, 160)} name="description" />
      <meta content="width=device-width, initial-scale=1" name="viewport" />

      <link
        as="font"
        crossOrigin="anonymous"
        href="/fonts/RimaAvant-Arte-Regular.woff2"
        rel="preload"
        type="font/woff2"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/fonts/RimaAvant-Arte-Bold.woff2"
        rel="preload"
        type="font/woff2"
      />

      <link href="/site.webmanifest" rel="manifest" />
      <link color="#ffffff" href="/safari-pinned-tab.svg" rel="mask-icon" />
      <link href={mapThemeFavicon[theme]} rel="shortcut icon" />
      <meta content={mapThemeColor[theme]} name="msapplication-TileColor" />
      <meta content={mapThemeColor[theme]} name="theme-color" />
      <link
        href="/apple-touch-icon.png"
        rel="apple-touch-icon"
        sizes="180x180"
      />
      <link
        href={mapThemeIcon32[theme]}
        rel="icon"
        sizes="32x32"
        type="image/png"
      />
      <link
        href={mapThemeIcon16[theme]}
        rel="icon"
        sizes="16x16"
        type="image/png"
      />

      <link
        crossOrigin="anonymous"
        href="https://a.storyblok.com"
        rel="preconnect"
      />
      <link
        crossOrigin="anonymous"
        href="https://gtm.svc.avantarte.com"
        rel="preconnect"
      />
      <link
        crossOrigin="anonymous"
        href="https://images.avantarte.org"
        rel="preconnect"
      />
      <link
        crossOrigin="anonymous"
        href="https://api.svc.avantarte.com"
        rel="preconnect"
      />
      <link
        crossOrigin="anonymous"
        href="https://cdn.growthbook.io"
        rel="preconnect"
      />
      <link
        crossOrigin="anonymous"
        href="https://store.avantarte.com"
        rel="preconnect"
      />
      <link
        crossOrigin="anonymous"
        href="https://cdn.shopify.com"
        rel="preconnect"
      />

      {canonical && <link href={canonical} rel="canonical" />}
    </NextHead>
  );
};

export default Head;
